import {
    type GetApiBarberShiftId400,
    type GetApiBarberShiftId401,
    type GetApiBarberShiftId403,
    type GetApiBarberShiftIdPathParams,
    type GetApiBarberShiftIdQueryKey,
    type GetApiBarberShiftIdQueryResponse,
    type ResponseErrorConfig,
    useGetApiBarberShiftId,
} from '@barbershop/api/barber'
import type { QueryObserverOptions } from '@tanstack/react-query'

interface useShiftProps {
    params: GetApiBarberShiftIdPathParams
    query?: Partial<
        QueryObserverOptions<
            GetApiBarberShiftIdQueryResponse,
            ResponseErrorConfig<
                GetApiBarberShiftId400 | GetApiBarberShiftId401 | GetApiBarberShiftId403
            >,
            GetApiBarberShiftIdQueryResponse,
            GetApiBarberShiftIdQueryResponse,
            GetApiBarberShiftIdQueryKey
        >
    >
}

export const useShift = ({ params, query }: useShiftProps) => {
    const { data, isLoading } = useGetApiBarberShiftId(params.id, {
        query,
    })

    return { shift: data, isLoading }
}
